import type { OpenZeppelinGovernor } from "contracts/bindings/OpenZeppelinGovernor"

/*
  If the governor implements `COUNTING_MODE`, it is of GovernanceType.OPENZEPPELINGOVERNOR
  with Bravo compatibilty.
*/
export const implementsBravo = async (
  governor: OpenZeppelinGovernor,
): Promise<boolean> => {
  try {
    await governor.COUNTING_MODE()
  } catch (e: any) {
    return false
  }

  return true
}
